import font from '../assets/tktyperegular-regular.woff2';
import tkms_font from '../assets/tkms-regular.woff2';
import tkms_head_font from '../assets/tkms-headline.woff2';

const fonts = `
@font-face {
  font-family: TKType;
  font-style: normal;
  font-weight: normal;
  font-display: fallback;
  src: url(${font}) format('woff2'); /* Chrome 26+, Opera 23+, Firefox 39+ */
}
@font-face {
  font-family: TKMS;
  font-style: normal;
  font-weight: normal;
  font-display: fallback;
  src: url(${tkms_font}) format('woff2'); /* Chrome 26+, Opera 23+, Firefox 39+ */
}
@font-face {
  font-family: TKMSHead;
  font-style: normal;
  font-weight: normal;
  font-display: fallback;
  src: url(${tkms_head_font}) format('woff2'); /* Chrome 26+, Opera 23+, Firefox 39+ */
}
`;

export default fonts;
